<template>
  <layout-form v-if="data">
    <template v-slot:Title
      ><span class="spacing-playground pa-6"></span>
      <v-divider vertical></v-divider
      ><span class="spacing-playground pa-6"> </span>
      <v-toolbar-title
        ><span class="title indigo--text"> {{ eventname }} </span>
      </v-toolbar-title>
    </template>
    <template v-slot:Main>
      <v-parallax dark :src="data.images.head || tmp" :height="windowSize.y - 119">
        <v-row align="center" justify="center">
          <v-col class="text-center" cols="12">
            <h3 class="font-weight-bold">
              {{ eventname }}
            </h3>
          </v-col>
        </v-row>
        <v-row align="center" justify="center">
          <v-col class="text-center" cols="12">
            <v-text-field
              v-model="Mob"
              outlined
              dark
              label="Mobile No."
              color="yellow"
              clearable
              prepend-icon="mdi-phone"
              v-if="!regis"
            ></v-text-field>
            <div v-else>
              <v-col class="text-center" cols="12">
                <v-text-field
                  :value="fullname"
                  filled
                  dark
                  label="Fullname"
                  readonly
                ></v-text-field>
              </v-col>
              <v-col class="text-center" cols="12">
                <v-text-field
                  :value="regis.Email"
                  filled
                  dark
                  label="Email Address"
                  readonly
                ></v-text-field>
              </v-col>
            </div>
          </v-col>
        </v-row>

        <v-row align="center" justify="center">
          <v-spacer />
          <v-col align="center" cols="12">
            <v-btn outlined large dark @click="Find" v-if="!regis">
              <v-icon>mdi-magnify</v-icon> Check IN</v-btn
            >

            <v-btn outlined large dark @click="Checkin" v-else
              ><v-icon>mdi-checkbox-marked-outline</v-icon> Check IN</v-btn
            >
          </v-col>
        </v-row>
      </v-parallax>
    </template>
  </layout-form>
  <div v-else-if="onload">
    <v-overlay :opacity="1" :value="onload">
      <v-progress-circular indeterminate size="64">
        Loading...
      </v-progress-circular>
    </v-overlay>
  </div>
  <not-found v-else />
</template>

<script>
import NotFound from "@/components/404.vue";
import layoutForm from "@/layouts/main.vue";

//import event from "@/Mockup/event.json";
//import regisdata from "@/Mockup/regisdata.json";
const API = process.env.VUE_APP_API;

export default {
  name: "Home",
  components: {
    layoutForm,
    NotFound,
  },
  data() {
    return {
      windowSize: {
        x: 0,
        y: 0,
      },
      tmp:require(`@/assets/xxx.jpg`),
      Mob: "",
      data: null,
      eventname: "",
      regis: null,
      onload: false,
    };
  },
  computed: {
    fullname: {
      get() {
        let fullname = this.regis.Name;
        if (this.regis.LastName)
          fullname = this.regis.Name + " " + this.regis.LastName;
        return fullname;
      },
    },
  },
  mounted() {
    this.windowSize = { x: window.innerWidth, y: window.innerHeight };
    this.init();
    window.addEventListener("resize", () => this.onResize());
    // console.log(process.env.VUE_APP_API);
  },
  methods: {
    async delRegis(mobileno) {
      // /v2/regis/:eventid/del/:mobileno
      this.onload = true;
      try {
        let rest = await axios.delete(
          `${API}/regis/${this.$route.params.id}/del/${mobileno}`
        );
        // console.log(rest)
        this.onload = false;
        return rest.data;
      } catch (e) {
        console.log(e);
        return [];
      }
    },
    async sendckeckin(mobileno) {
      ///v2/regis/:eventid/checkin/:mobileno
      this.onload = true;
      try {
        let rest = await axios.patch(
          `${API}/regis/${this.$route.params.id}/checkin/${mobileno}`
        );
        console.log(rest);
        this.onload = false;
        return rest.data;
      } catch (e) {
        console.log(e);
        return [];
      }
    },
    async getRegis() {
      this.onload = true;
      try {
        let rest = await axios.get(
          `${API}/regis/${this.$route.params.id}/list`
        );
        this.onload = false;
        return rest.data;
      } catch (e) {
        console.log(e);
        return [];
      }
    },
    async getEvent() {
      this.onload = true;
      try {
        let rest = await axios.get(`${API}/event`);
        this.onload = false;
        return rest.data;
      } catch (e) {
        console.log(e);
        return [];
      }
    },
    onResize() {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight };
      // console.log(this.windowSize);
    },

    async Find() {
      let regisdata = await this.getRegis();

      let rest = regisdata.filter((e) => e.Mobile == this.Mob);
      // console.log(rest);
      if (rest.length > 0) {
        this.regis = rest[0];
      }
    },
    async Checkin() {
      await this.sendckeckin(this.regis.Mobile);
      alert("Complete check-in");
      window.location.replace("http://www.vstecs.co.th");
    },
    async init() {
      let x = await this.getEvent();

      let rest = x.filter((e) => e.uuid == this.$route.params.id);

      if (rest.length > 0) {
        this.data = rest[0];
        this.eventname = this.data.eventname;
      }
    },
  },
};
</script>
<style scoped>
.custom-placeholer-color input,
.custom-label-color input {
  color: red !important;
}
</style>
